import { render, staticRenderFns } from "./AllowedCountries.vue?vue&type=template&id=54753ddc"
import script from "./AllowedCountries.vue?vue&type=script&lang=js"
export * from "./AllowedCountries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports